import { BaseDropdown } from './component/BaseDropdown';
import { useDropdownOptions } from '../../hooks/useDropdownOptions';
import { BusinessDropdownProps } from './component/type';

const COLUMN_NAMES: string[] = ['Code', 'Description'];

export const CalendarIdsDropdown = (props: BusinessDropdownProps) => {
  const shouldPreventApiCall = props.disabled || props.readOnly;

  const { options: calendarIdsOptions, loading } = useDropdownOptions({
    apiId: 'internal.v1.base-tables',
    operationId: 'GET /promptValues/{windowId}',
    labelAttribute: 'calendarDescription',
    valueAttribute: 'calendarId',
    params: {
      windowId: 'calenderIds',
    },
    shouldPreventApiCall,
  });

  return <BaseDropdown {...props} loading={loading} options={calendarIdsOptions} columnNames={COLUMN_NAMES} />;
};
